import {
  bg_image_default
} from "./chunk-C7OYLNPV.esm.js";
import {
  image_default
} from "./chunk-L7ID46IZ.esm.js";
import "./chunk-WY4FP4ZF.esm.js";
import {
  useImage
} from "./chunk-WBMNQIIL.esm.js";
import {
  config
} from "./chunk-RDOW37CZ.esm.js";
import "./chunk-QPGVD7NS.esm.js";

// src/index.ts
var src_default = image_default;
export {
  bg_image_default as BgImage,
  config,
  src_default as default,
  useImage
};
//# sourceMappingURL=index.esm.js.map